
import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import { useState } from 'react';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function Services() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const services = [
    {
      title: 'GRI Sürdürülebilirlik Raporu',
      description: 'Global Reporting Initiative standartlarına uygun sürdürülebilirlik raporları hazırlıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20team%20preparing%20GRI%20sustainability%20report%20in%20modern%20office%20environment%2C%20corporate%20responsibility%20documents%20and%20charts%20on%20table%2C%20sustainable%20business%20reporting&width=400&height=200&seq=401&orientation=landscape',
      features: ['GRI Universal Standards', 'Materialize Analizi', 'Stakeholder Katılımı', 'Doğrulama Desteği'],
      duration: '12-16 hafta'
    },
    {
      title: 'TSRS Sürdürülebilirlik Raporu',
      description: 'Türkiye Sürdürülebilirlik Raporlama Standartları\'na uygun raporlama hizmetleri.',
      image: 'https://readdy.ai/api/search-image?query=Turkish%20sustainability%20reporting%20standards%20TSRS%20documentation%20with%20Turkish%20flag%20and%20business%20charts%2C%20professional%20corporate%20sustainability%20compliance&width=400&height=200&seq=402&orientation=landscape',
      features: ['TSRS Standartları', 'Yerel Uyumluluk', 'Türkçe Raporlama', 'Yasal Gereklilikler'],
      duration: '10-14 hafta'
    },
    {
      title: 'CSRD Sürdürülebilirlik Raporu',
      description: 'AB\'nin Corporate Sustainability Reporting Directive gerekliliklerine uyum.',
      image: 'https://readdy.ai/api/search-image?query=European%20Union%20CSRD%20sustainability%20reporting%20directive%20compliance%20with%20EU%20flag%20and%20corporate%20documents%2C%20professional%20business%20environment&width=400&height=200&seq=403&orientation=landscape',
      features: ['CSRD Direktifi', 'ESRS Standartları', 'AB Uyumluluk', 'Digital Raporlama'],
      duration: '14-18 hafta'
    },
    {
      title: 'ESG Danışmanlığı',
      description: 'Çevresel, Sosyal ve Kurumsal Yönetim kriterlerinde kapsamlı danışmanlık hizmetleri.',
      image: 'https://readdy.ai/api/search-image?query=ESG%20environmental%20social%20governance%20consulting%20with%20business%20professionals%20analyzing%20sustainability%20metrics%20and%20charts%20in%20modern%20office&width=400&height=200&seq=404&orientation=landscape',
      features: ['ESG Stratejisi', 'Risk Yönetimi', 'Performans Ölçümü', 'Yatırımcı İlişkileri'],
      duration: '8-12 hafta'
    },
    {
      title: 'GAP Analizi',
      description: 'Mevcut durumunuz ile hedef sürdürülebilirlik standartları arasındaki farkları belirliyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Business%20gap%20analysis%20presentation%20with%20charts%20and%20graphs%20showing%20sustainability%20performance%20metrics%2C%20professional%20consulting%20environment&width=400&height=200&seq=405&orientation=landscape',
      features: ['Mevcut Durum Analizi', 'Hedef Belirleme', 'Eylem Planı', 'Öncelik Matrisi'],
      duration: '4-6 hafta'
    },
    {
      title: 'Ecovadis Danışmanlığı',
      description: 'Ecovadis sürdürülebilirlik değerlendirmesinde yüksek skor almanızı sağlıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Ecovadis%20sustainability%20assessment%20gold%20medal%20award%20with%20business%20professionals%20celebrating%20achievement%20in%20corporate%20office%20environment&width=400&height=200&seq=406&orientation=landscape',
      features: ['Platform Yönetimi', 'Skor Optimizasyonu', 'Belge Hazırlığı', 'İyileştirme Planı'],
      duration: '6-10 hafta'
    },
    {
      title: 'SBTi Danışmanlığı',
      description: 'Science Based Targets initiative metodolojisi ile bilim temelli iklim hedefleri belirliyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Science%20based%20targets%20initiative%20SBTi%20climate%20goals%20with%20environmental%20scientists%20analyzing%20carbon%20data%20and%20climate%20charts&width=400&height=200&seq=407&orientation=landscape',
      features: ['Hedef Belirleme', 'SBTi Onayı', 'İklim Stratejisi', 'Net Zero Planlama'],
      duration: '8-12 hafta'
    },
    {
      title: 'CDP Raporu',
      description: 'Carbon Disclosure Project raporlamasında A-List skorları elde etmenizi destekliyoruz.',
      image: 'https://readdy.ai/api/search-image?query=CDP%20Carbon%20Disclosure%20Project%20A-list%20scoring%20report%20with%20environmental%20data%20charts%20and%20climate%20performance%20metrics%20in%20professional%20setting&width=400&height=200&seq=408&orientation=landscape',
      features: ['CDP İklim', 'CDP Su', 'CDP Orman', 'A-List Stratejisi'],
      duration: '6-8 hafta'
    }
  ];

  return (
    <>
      <section id="hizmetler" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Sürdürülebilirlik Hizmetlerimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              16+ yıllık deneyimimizle uçtan uca sürdürülebilirlik danışmanlığı hizmetleri sunuyoruz. 
              Her projeyi özenle yönetir, müşterilerimizin başarısını garanti ederiz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {services.map((service, index) => (
              <Card 
                key={index} 
                className="p-6 group hover:shadow-xl hover:scale-105 transition-all duration-300 animate-in fade-in slide-in-from-bottom-4 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
                onClick={() => window.location.href = '/iletisim'}
              >
                <div className="relative overflow-hidden rounded-lg mb-4">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-32 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-emerald-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                  {service.title}
                </h3>
                
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="space-y-2 mb-4">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-xs text-gray-500">
                      <i className="ri-check-line text-emerald-500 mr-2 text-sm"></i>
                      {feature}
                    </div>
                  ))}
                </div>
                
                <div className="flex items-center justify-between text-xs text-gray-500 mb-4">
                  <div className="flex items-center">
                    <i className="ri-time-line mr-1"></i>
                    {service.duration}
                  </div>
                </div>
                
                <div className="w-full">
                  <Button 
                    size="sm" 
                    className="w-full group-hover:bg-emerald-700 transition-colors whitespace-nowrap"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsQuoteModalOpen(true);
                    }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-file-text-line"></i>
                    </div>
                    Teklif Al
                  </Button>
                </div>
              </Card>
            ))}
          </div>

          <div className="text-center">
            <Link to="/hizmetler">
              <Button size="lg" variant="outline" className="group hover:scale-105 transition-all duration-200 whitespace-nowrap">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-list-check-line group-hover:scale-110 transition-transform"></i>
                </div>
                Tüm Hizmetleri Görüntüle
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
}